<template>
  <div class="daily-menu-container">
    <div class="header-container">
      <Header></Header>
      <i class="material-icons arrow" @click="handleBack">arrow_back</i>
      <i v-if="autenticated" class="material-icons  download" @click="downloadMenu">download</i>
    </div>
    <div class="daily-menu">
      <div class="inside-border">
        <div id="title-daily-menu">
      <h1>Menu del giorno</h1>
    </div>
        <p class="stars-splitter">&#9733;&nbsp;&nbsp;&#9733;&nbsp;&nbsp;&#9733;&nbsp;&nbsp;&#9733;&nbsp;&nbsp;&#9733;</p>  
      <div class="category" v-if="antipasto.show">
        <p class="item-name">{{ antipasto.title }}</p>
        <p class="item-description">{{ antipasto.description }}</p>
        <p class="stars-splitter">&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</p>
      </div>
      <div class="category" v-if="primoPiatto.show">
        <p class="item-name">{{ primoPiatto.title }}</p>
        <p class="item-description">{{ primoPiatto.description }}</p>
        <p class="stars-splitter">&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</p>
      </div>
      <div class="category" v-if="secondoPiatto.show">
        <p class="item-name">{{ secondoPiatto.title }}</p>
        <p class="item-description">{{ secondoPiatto.description }}</p>
        <p class="stars-splitter">&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</p>
      </div>
      <div class="category" v-if="frutta.show">
        <p class="item-name">{{ frutta.title }}</p>
        <p class="item-description">{{ frutta.description }}</p>
        <p class="stars-splitter">&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</p>
      </div>
      <div class="category" v-if="bevande.show">
        <p class="item-name">{{ bevande.title }}</p>
        <p class="item-description">{{ bevande.description }}</p>
      </div>
      <div class="infinity-container">
        <hr/>
      <i class="material-icons infinity">all_inclusive</i>
      <hr/>
    </div>
      <div class="total-price">
        <p ref="priceText">Prezzo: €{{ menuPrice.toFixed(2) }}</p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { fetchDailyMenu } from '@/api/DailyMenuAPI'; 
import { downloadDailyMenuImage } from '@/utils/downloadDailyMenu';
import { isAuthenticated } from '@/router/index'
import Header from '@/components/homepage/Header.vue';

export default {
  components: {
    Header
  },
  data() {
    return {
      antipasto: {},
      primoPiatto: {},
      secondoPiatto: {},
      frutta: {},
      bevande: {},
      menuPrice: 0,
      animatedPrice: 0,
      thereIs: false,
      autenticated: false
    };
  },
  async mounted() {
    if(isAuthenticated()){
      this.autenticated = true;
    }
    await this.fetchMenuData();
    this.animatePrice();
  },
  methods: {
    async fetchMenuData() {
      try {
        const dailyMenuData = await fetchDailyMenu(); // Esegui la chiamata API per ottenere i dati del menu giornaliero
        if (dailyMenuData.length > 0) {
          const dailyMenu = dailyMenuData[0];
          this.antipasto = {
            title: dailyMenu.antipasto_title,
            description: dailyMenu.antipasto_description,
            show: dailyMenu.antipasto_show
          };
          this.primoPiatto = {
            title: dailyMenu.primo_piatto_title,
            description: dailyMenu.primo_piatto_description,
            show: dailyMenu.primo_piatto_show
          };
          this.secondoPiatto = {
            title: dailyMenu.secondo_piatto_title,
            description: dailyMenu.secondo_piatto_description,
            show: dailyMenu.secondo_piatto_show
          };
          this.frutta = {
            title: dailyMenu.frutta_title,
            description: dailyMenu.frutta_description,
            show: dailyMenu.frutta_show
          };
          this.bevande = {
            title: dailyMenu.bevande_title,
            description: dailyMenu.bevande_description,
            show: dailyMenu.bevande_show
          };
          this.menuPrice = parseFloat(dailyMenu.menu_price);
          this.animatedPrice = parseFloat(dailyMenu.animated_price);
          this.thereIs = dailyMenu.there_is;
        }
      } catch (error) {
        console.error("Error loading daily menu:", error);
      }
    },
    animatePrice() {
      gsap.to(this.$refs.priceText, {
        duration: 1,
        opacity: 0.2,
        yoyo: true,
        repeat: -1
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
    downloadMenu(){
      downloadDailyMenuImage(800);
    }
  }
};
</script>



<style scoped>
#title-daily-menu {
  margin-top: 40px;
  margin-bottom: 20px;
  color: var(--text-color);
}
#title-daily-menu h1{
  display: flex;
  justify-content: center;
  align-items: center;
 font-size: 35px;
  font-weight: bold;
}
.infinity-container{
display: flex;
}
.infinity-container hr{
  flex: 1;
  margin: 10px;
  border: 1px ;
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.infinity {
  flex: 1; 
  max-width: 20px; 
  text-align: center; 
  margin: 0 auto; 
}



.arrow {
  font-size: 40px;
  color: var(--text-color);
  position: fixed;
  left: 10px;
  top: 10px;
  z-index: 1000;
}
.download{
  font-size: 40px;
  color: var(--text-color);
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 1000;
}
.stars-splitter{
  text-align: center;
  margin-bottom: 0px;
}
.header-container {
  text-align: center;
  padding-bottom: 60px;
}

.daily-menu-container {
  min-height: 100vh;
  background-color: var(--background-color);
  padding: 10px;
  padding-bottom: 50px;
  font-family: "Great Vibes", cursive !important;
  font-size: 22px;
}

.inside-border{
  border: double goldenrod;
}

.daily-menu {
  padding: 15px;
  background-color: var(--header-color);
  color: var(--text-color);
  box-shadow: 0px 0px 15px rgba(255, 255, 255, 0.9);
}

.category {
  padding: 25px;
  padding-bottom: 20px;
  margin-bottom: 0px;
  margin-left: 10px;
}


.item-name {
  font-weight: bold;
  text-align: center;
  color: goldenrod;
  margin-bottom: 20px;
  font-size: 30px;
}

.item-description {
  margin-top: 5px;
  text-align: center;
  color: var(--text-color);
}

.total-price {
  margin-top: 20px;
  font-weight: bold;
  text-align: center;
  font-size: 30px;
  }
</style>
